export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7S5 5.13 5 9m4.5 0a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1-5 0\"/>"
};